// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"4eb1ace8","374":"5e6cccbe","994":"4eb1ace8"}[chunkId] + ".chunk.css";
};